import { ApiErrorResponse } from '@/api/common/apiErrorResponse.ts'
import { BaseException } from '@/domain/exceptions/baseException.ts'

export class AlreadyExistsException extends BaseException {
  constructor(originalError?: ApiErrorResponse) {
    super('Object already exists', { originalError })
  }
}
